import {
  Box,
  Button,
  Container,
  Divider,
  Group,
  NumberInput,
  Select,
  SimpleGrid,
  Switch,
  Text,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import BenchBreadcrumbs from "../UIComponent/Components/BenchBreadcrumbs";
import BenchSettingsBreadcrumbs from "../UIComponent/Components/BenchSettingsBreadcrumbs";
import BenchHeading from "../pages/UI/BenchHeading";
import BenchTopHeader from "../UIComponent/Components/BenchTopHeader";
import { IconClock, IconPackage, IconSettings } from "@tabler/icons-react";
import BenchCard from "../UIComponent/Components/BenchCard";
import { toast } from "react-toastify";
import {
  collection,
  CollectionReference,
  doc,
  DocumentData,
  FieldValue,
  getDoc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { useAppSelector } from "../../hooks/hooks";
import { db } from "../../firebase/FirebaseCredential";
import { RootState } from "../../store/store";
import BenchIconBackground from "../UIComponent/BenchIconBackground";
import { set } from "date-fns";

const MemberFreeze = () => {
  const [durationType, setDurationType] = useState<string>("days");
  const [maximumfreezeallowed, setMaximumfreezeallowed] = useState<number>(1);
  const [maximumdurationallowed, setMaximumdurationallowed] =
    useState<number>(1);
  const [fetcheddata, setFetchedData] = useState<boolean>(false);
  const companyId = useAppSelector(
    (state: RootState) => state.session?.company_id,
  );
//   const [enabled, setenabled] = useState<boolean>(false);

  const fetchmemberfreezedata = async () => {
    if (!companyId) return;

    const memberfreezedoc = doc(
      db,
      "companyprofile",
      companyId,
      "companysettings",
      "memberfrezzsettings",
    );
    const memberfreezedata = await getDoc(memberfreezedoc);
    if (memberfreezedata.exists()) {
      const data = memberfreezedata.data();
      setMaximumfreezeallowed(data.maximumfreezeallowed);
      setMaximumdurationallowed(data.maximumdurationallowed);
      setDurationType(data.durationType);
      setFetchedData(true);
    }
  };

  useEffect(() => {
    fetchmemberfreezedata();
  }, [companyId]);

  const handleSaveSetting = async () => {
    if (!companyId) {
      toast.error("Company ID is missing. Please try refreshing the page.");
      return;
    }

    if (!maximumdurationallowed || !maximumfreezeallowed) {
      toast.error("Enter all the fields ");
      return;
    }
    // if (!enabled) {
    //   toast.error("Enable the switch to activate the settings");
    //   return;
    // }

    const memberfreezedata = {
      maximumfreezeallowed,
      maximumdurationallowed,
      durationType,
      created_at: serverTimestamp(),
    };

    const updateMemberfreeze = doc(
      db,
      "companyprofile",
      companyId,
      "companysettings",
      "memberfrezzsettings",
    );
    await setDoc(updateMemberfreeze, memberfreezedata);

    console.log(maximumfreezeallowed, maximumdurationallowed, durationType);
    toast.success("Member freeze settings saved successfully ");
    setFetchedData(true);
  };

  const breadcrumbs = [
    {
      label: "Member Freeze",
    },
  ];
  return (
    <Container size="lg"> <Box
                sx={(theme) => ({
                  position: "sticky",
                  top: 110, // Avoid overlapping the fixed navbar
                  zIndex: 100,
                  backgroundColor: "#FAFAFA",
                  paddingTop: theme.spacing.sm,
                  //paddingBottom: theme.spacing.xs,
                  marginTop: `-${theme.spacing.sm}`,
                })}
              >
      <SimpleGrid cols={2}>
        <BenchSettingsBreadcrumbs links={breadcrumbs} />
        <Group position="right">
          {!fetcheddata && (
            <Button onClick={() => handleSaveSetting()}>Save</Button>
          )}
          {fetcheddata && (
            <Button onClick={() => setFetchedData(false)}>Edit</Button>
          )}
        </Group>
      </SimpleGrid>
      <Divider my="md" /></Box>
      <BenchTopHeader
        icon={<IconSettings />}
        title="Member Freeze"
        description="Setup the member freeze configuration, settings and preferences for your business."
      />

      {!fetcheddata ? (
        <BenchCard>
        <SimpleGrid cols={2}>
            <BenchHeading title="Freeze settings" order={4} fw={600} fz="h1" />
    
          </SimpleGrid>
          <SimpleGrid cols={2} mt="md" p="xl">
            <NumberInput   
              label="Maximum no of freezes allowed"
              placeholder="Enter the number of freezes allowed per membership"
              required
              value={maximumfreezeallowed}
              onChange={(value) => setMaximumfreezeallowed(value as number)}
              min={1}
            />

            <Select
              label="Maximum duration of freeze allowed"
              placeholder="Enter the maximum duration of freeze allowed per membership"
              data={[
                { label: "Days", value: "days" },
                // { label: "Months", value: "months" },
              ]}
              value={durationType}
              onChange={(value) => setDurationType(value as string)}
              required
            />
            {durationType == "days" ? (
              <NumberInput
                label="No of allowed days to freeze"
                placeholder="Enter the number of allowed days to freeze"
                required
                value={maximumdurationallowed}
                onChange={(value) => setMaximumdurationallowed(value as number)}
                min={1}
              />
            ) : (
              <NumberInput
                label="No of allowed Months to freeze"
                placeholder="Enter the number of allowed Months to freeze"
                required
                value={maximumdurationallowed}
                onChange={(value) => setMaximumdurationallowed(value as number)}
                min={1}
              />
            )}

               {/* <BenchCard> */}
           {/* <Switch
            label="Enable the Switch"
            checked={enabled}
            onChange={(event) => setenabled(event.currentTarget.checked)}
          /> </BenchCard> */}
          </SimpleGrid>
        </BenchCard>
      ) : (
        <>
          <BenchCard>
            <BenchHeading
              title="Member Freeze Configuration"
              order={4}
              fw={600}
              fz="h1"
            />

            <SimpleGrid
              cols={2} // Responsive: 1 column on mobile, 2 on desktop
              spacing="lg"
              mt="md"
              p="xl"
            >
              {/* Card 1: Combined Duration Metric */}
              <BenchCard
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Group align="center">
                  <Group>
                    <BenchIconBackground icon={<IconClock />} size={30} />
                    <Text
                      size="sm"
                      c="dimmed"
                      fw={600}
                      lts="0.5px"
                      tt="uppercase"
                    >
                      Max Freeze Duration
                    </Text>
                  </Group>
                </Group>

                <div>
                  <Group align="baseline">
                    <Text
                      style={{ fontSize: "2.75rem", lineHeight: 1 }}
                      fw={700}
                    >
                      {maximumdurationallowed || "0"}
                    </Text>
                    <Text size="sm" c="dimmed" fw={500} tt="capitalize">
                      {durationType || "days"}
                    </Text>
                  </Group>
                </div>
              </BenchCard>

              {/* Card 2: Maximum Count Metric */}
              <BenchCard
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Group align="center" mb="md">
                  <Group>
                    <BenchIconBackground icon={<IconPackage />} size={30} />
                    <Text
                      size="sm"
                      c="dimmed"
                      fw={600}
                      lts="0.5px"
                      tt="uppercase"
                    >
                      Max Allowed Freezes
                    </Text>
                  </Group>
                </Group>

                <div>
                  <Text style={{ fontSize: "2.75rem", lineHeight: 1 }} fw={700}>
                    {maximumfreezeallowed || "0"}
                  </Text>
                </div>
              </BenchCard>
              
            </SimpleGrid>
          </BenchCard>
        </>
      )}
    </Container>
  );
};

export default MemberFreeze;
function updateDocument(
  updateMemberfreeze: CollectionReference<DocumentData, DocumentData>,
  memberfreezedata: {
    maximumfreezeallowed: number;
    maximumdurationallowed: number;
    durationType: string;
    created_at: FieldValue;
  },
) {
  throw new Error("Function not implemented.");
}
